/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QueueStatistics,
    QueueStatisticsFromJSON,
    QueueStatisticsFromJSONTyped,
    QueueStatisticsToJSON,
} from './QueueStatistics';

/**
 * 
 * @export
 * @interface QueueStatisticsResponse
 */
export interface QueueStatisticsResponse {
    /**
     * 
     * @type {Array<QueueStatistics>}
     * @memberof QueueStatisticsResponse
     */
    items: Array<QueueStatistics>;
}

export function QueueStatisticsResponseFromJSON(json: any): QueueStatisticsResponse {
    return QueueStatisticsResponseFromJSONTyped(json, false);
}

export function QueueStatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueueStatisticsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(QueueStatisticsFromJSON)),
    };
}

export function QueueStatisticsResponseToJSON(value?: QueueStatisticsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(QueueStatisticsToJSON)),
    };
}

